module.exports = __webpack_public_path__ + "img/img_wangyiyun@2x.28c770c9.png";